import { getOrdersStatusList } from '../../../services/SalaryCards/OrderStatusList'
import { Dispatch } from 'react'
import {
  FetchOrderStatusListFailureAction,
  FetchOrderStatusListRequestAction,
  FetchOrderStatusListSuccessAction,
  orderStatusListType,
  SalaryCardActions,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'

export const fetchOrderStatusListRequest =
  (): FetchOrderStatusListRequestAction => ({
    type: SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_REQUEST,
  })

export const fetchOrderStatusListSuccess = (
  orderStatusList: orderStatusListType[]
): FetchOrderStatusListSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_SUCCESS,
  payload: orderStatusList,
})

export const fetchOrderStatusListFailure = (
  error
): FetchOrderStatusListFailureAction => ({
  type: SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_FAILURE,
  payload: error,
})

export const fetchOrderList = (date: { startDate: string, endDate: string }) => {
  return async (dispatch: Dispatch<SalaryCardActions>) => {
    dispatch(fetchOrderStatusListRequest())

    try {
      const data = await getOrdersStatusList(date)

      dispatch(fetchOrderStatusListSuccess(data))
    } catch (error) {
      dispatch(fetchOrderStatusListFailure(error.message))
    }
  }
}
